module.exports = __webpack_public_path__ + "fonts/montserrat-thinitalic-webfont.91fc678.woff2";